export default "__VITE_ASSET__BX7nSqd3__"